import React from "react";

export function PartnerSettingsCard({
  children,
}: {
  children: React.ReactNode;
}) {
  return <div className="flex flex-col gap-4 rounded-lg p-4">{children}</div>;
}
